export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const MAX_IMAGE_SIZE_MB = 20;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

export function validateImageFile(file: File): string | null {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return 'Kun JPG, PNG eller WEBP er tilladt.';
  }

  if (file.size > MAX_IMAGE_SIZE_BYTES) {
    return `Billedet er for stort. Maksimal størrelse er ${MAX_IMAGE_SIZE_MB} MB.`;
  }

  return null;
}
